import { useRovoWorkspace, useUnitsEnabled } from '@townsquare/collab-context';
import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { generatePath } from '@townsquare/router/primitives/path';
import { tagsDirectoryRoute } from '@townsquare/routes/tags-directory';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';

import { useProjectsAndGoalsSite } from './use-projects-and-goals-site';

export const useTagsDirectoryRoute = (): { tagsDirectoryPath: string; isTagsDirectoryEnabled: boolean } => {
	const routeDependencies = useRouteDependencies();
	const { cloudId: tagsDirectoryCloudId, hasProjectsAccess, hasGoalsAccess } = useProjectsAndGoalsSite();
	const currentCloudId = useRovoWorkspace();
	const unitsEnabled = useUnitsEnabled();

	const hasTagsDirectoryInCurrentSite = tagsDirectoryCloudId === currentCloudId;
	const hasTagsDirectoryInUnit = !!tagsDirectoryCloudId && tagsDirectoryCloudId !== currentCloudId;
	const isTagsDirectoryEnabled = hasProjectsAccess || hasGoalsAccess;

	const basePath = generatePath(tagsDirectoryRoute, routeDependencies);

	// If gate is off or current site has tags directory, return base path
	if (!unitsEnabled || hasTagsDirectoryInCurrentSite) {
		return { tagsDirectoryPath: basePath, isTagsDirectoryEnabled };
	}

	// If tags directory is enabled in the unit, return path with cloudId
	if (hasTagsDirectoryInUnit) {
		const queryParams = createSearchParamsFromCurrentUrl({ cloudId: tagsDirectoryCloudId });
		return { tagsDirectoryPath: `${basePath}?${queryParams.toString()}`, isTagsDirectoryEnabled };
	}

	return { tagsDirectoryPath: basePath, isTagsDirectoryEnabled };
};
